// extracted by mini-css-extract-plugin
module.exports = {"column":"audit-trail_column__2Ay4_"};